/**
* Scrolling Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'scrolling-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let tallestCard = 0;
      const descriptionSlide = document.querySelectorAll( '.description-slide' );
      descriptionSlide.forEach( ( slide, index ) => {
        setTimeout( () => {
          if ( slide.offsetHeight > tallestCard ) {
            tallestCard = slide.offsetHeight;
          }
        }, 0 );
      } );

      $( '.scrolling-content' ).each( function() {
        const main = new Splide( '.description-slider__splide', {
          type: 'loop',
          focus: 'center',
          arrows: false,
          pagination: false,
          perPage: 1,
          speed: 1000,
          direction: 'ltr',
          mediaQuery: 'min',
          breakpoints: {
            1024: {
              direction: 'ttb',
              height: $( '.scrolling-content' ).height(),
            },
          },
        } );

        const secondary = new Splide( '.image-slider__splide', {
          type: 'fade',
          arrows: false,
          pagination: true,
          paginationDirection: 'ttb',
          perPage: 1,
          speed: 1000,
        } );

        main.sync( secondary );
        main.mount();
        secondary.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-content', COMPONENT );
} )( app );
